export default function StraightShortArrowIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="46.188" height="45.567" viewBox="0 0 46.188 45.567">
    <g id="imggal_arrow_r" transform="translate(44.067 1.5) rotate(90)">
      <g id="Gruppe_43" data-name="Gruppe 43" transform="translate(21.283 42.567) rotate(-135)">
        <path id="Pfad_24" data-name="Pfad 24" d="M0,0,30.1,30.1" transform="translate(0 0)" fill="none" stroke="#fff" stroke-width="3"/>
        <path id="Pfad_23" data-name="Pfad 23" d="M30.1,0V30.1H0" transform="translate(0 0)" fill="none" stroke="#fff" stroke-width="3"/>
      </g>
    </g>
  </svg>;
}